import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import AuditLogsHome from './Index.vue';
import AuditLogsIndicators from './Indicators.vue';
import AuditLogsSummary from './Summary.vue';

// Audit Logs e uma feature reescrita do zero no MensageiroPro (substitui o
// modulo Enterprise original). Auditoria e INCONDICIONAL - sempre disponivel,
// SEM feature flag (o registro nunca pode ser desligado). Acesso restrito
// apenas a administradores (permissions: ['administrator']).
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/audit-logs'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'auditlogs_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'auditlogs_list',
          meta: {
            permissions: ['administrator'],
          },
          component: AuditLogsHome,
        },
        {
          path: 'indicators',
          name: 'auditlogs_indicators',
          meta: {
            permissions: ['administrator'],
          },
          component: AuditLogsIndicators,
        },
        {
          path: 'summary',
          name: 'auditlogs_summary',
          meta: {
            permissions: ['administrator'],
          },
          component: AuditLogsSummary,
        },
      ],
    },
  ],
};
